module.exports = __webpack_public_path__ + "static/media/selectedOpenedLetter.3a9b08de.svg";